export const CaracteresString = (string: string, limite: number) => {
    const frase = string.substring(0,limite)
    if(frase.length < limite) {
        return frase
    } else {
        return frase + '...'
    }
}